import { render } from "./Roadbases.vue?vue&type=template&id=4561325d"
import script from "./Roadbases.vue?vue&type=script&lang=js"
export * from "./Roadbases.vue?vue&type=script&lang=js"
script.render = render

export default script